import React, { useState, useEffect } from "react";
import {
  MdHome,
  MdPerson,
  MdPeople,
  MdExpandLess,
  MdExpandMore,
  MdArticle,
  MdWork,
  MdBadge,
  MdComment,
  MdAnalytics,
  MdSettings,
  MdAssessment,
  MdFiberManualRecord,
  MdCheckCircle
} from "react-icons/md";
import logo from '../images/logo.png';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useSelector } from "react-redux";
import { APP_BASE_URL } from "../config/api";
import { getStatusColor } from "./ui";

const Sidebar = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [showDriversSublist, setShowDriversSublist] = useState(false);
  const [activeItem, setActiveItem] = useState('home');
  const [recentDrivers, setRecentDrivers] = useState([]);
  const { user, token, isAuthenticated, isLoading } = useSelector((state) => state.auth);
  const { accountId } = useSelector((state) => state.account);

  const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8001';

  // useEffect(() => {
  //   if (showDriversSublist) {
  //     const fetchRecentDrivers = async () => {
  //       try {
  //         const response = await fetch(`${APP_BASE_URL}/admin/safe/recent_drivers/${accountId}`);
  //         const data = await response.json();
  //         console.log("📥 Fetched Report Data:", data);
  //         // Map backend status to frontend display status if needed, or directly use
  //         const formattedDrivers = data.map(driver => ({
  //           id: driver.driver_id,
  //           label: `${driver.first_name} ${driver.last_name}`,
  //           status: driver.status === 'created' ? 'pending' : (driver.status === 'released' ? 'active' : 'review') // Map backend status
  //         }));
  //         setRecentDrivers(formattedDrivers);
  //       } catch (error) {
  //         console.error("Error fetching recent drivers:", error);
  //         setRecentDrivers([]); // Clear on error
  //       }
  //     };
  //     fetchRecentDrivers();
  //   }
  // }, [showDriversSublist, token, API_BASE_URL]);

  const BUSINESS_BASE_URL = process.env.REACT_APP_BUSINESS_URL || 'https://records.4safedrivers.com';
  const menuItems = [
    { id: 'home', label: 'All Drivers', icon: MdHome },
    { id: 'request', label: 'Request MVR', icon: MdPerson },
    { id: 'completedDrivers', label: 'Completed Drivers', icon: MdCheckCircle },
    {
      id: 'recentDrivers',
      label: 'Recent Drivers',
      icon: MdPeople,
      expandable: false,
      // subItems: recentDrivers
    },
    { id: 'businessPrice', label: 'Business Price', icon: MdArticle },
    { id: 'authWaitList', label: 'Authorization Wait List', icon: MdWork },
    { id: 'orderHistory', label: 'Order History', icon: MdBadge },
    { id: 'myAccount', label: 'My Account', icon: MdComment },
    { id: 'updatePaymentProfile', label: 'Update Payment Profile', icon: MdAssessment },
    { id: 'contact', label: 'Contact', icon: MdAnalytics },
    { id: 'authForm', label: 'Authorization Form', icon: MdSettings },
  ];

  // Status colors now use centralized getStatusColor from ui/riskStyles.js

  const handleItemClick = (itemId) => {
    setActiveItem(itemId);
    if (itemId === 'home') {
      navigate('?view=drivers');
    }
    else if (itemId === 'request') {
      window.location.href = `${BUSINESS_BASE_URL}/login?l=request&t=${token}`;
    }
    else if (itemId === 'completedDrivers') {
      navigate('?view=completedDrivers');
    }
    else if (itemId === 'recentDrivers') {
      // setShowDriversSublist(!showDriversSublist);
      navigate('?view=recentDrivers');
    }
    else if (itemId === 'businessPrice') {
      window.location.href = `${BUSINESS_BASE_URL}/login?l=business-price&t=${token}`;
    }
    else if (itemId === 'authWaitList') {
      window.location.href = `${BUSINESS_BASE_URL}/login?l=auth-wait-list&t=${token}`;
    }
    else if (itemId === 'orderHistory') {
      window.location.href = `${BUSINESS_BASE_URL}/login?l=order-history&t=${token}`;
    }
    else if (itemId === 'myAccount') {
      window.location.href = `${BUSINESS_BASE_URL}/login?l=my-account&t=${token}`;
    }
    else if (itemId === 'updatePaymentProfile') {
      window.location.href = `${BUSINESS_BASE_URL}/login?l=update-pay-pro&t=${token}`;
    }
    else if (itemId === 'contact') {
      window.location.href = `${BUSINESS_BASE_URL}/contact-us`;
    }
    else if (itemId === 'authForm') {
      window.location.href = `${BUSINESS_BASE_URL}/login?l=auth-form&t=${token}`;
    }
  };

  return (
    <div className="h-full flex flex-col bg-white">
      {/* Fixed Branding */}
      <div className="flex-shrink-0 border-b border-gray-100">
        <div className="px-4 py-4">
          <a href="#" className="flex items-center hover:opacity-80 transition-opacity">
            <img src={logo} alt="Logo" className="h-8 w-auto" />
          </a>
        </div>
      </div>

      {/* Scrollable Navigation */}
      <nav className="flex-1 overflow-y-auto px-3 py-4 space-y-1">
        {menuItems.map((item) => (
          <div key={item.id}>
            {/* Main Menu Item */}
            <div
              className={`group relative rounded-lg transition-all duration-200 ${activeItem === item.id
                ? 'bg-blue-50 border border-blue-200'
                : 'hover:bg-gray-50'
                }`}
            >
              <button
                onClick={() => handleItemClick(item.id)}
                className="w-full flex items-center px-3 py-2.5 text-sm font-medium transition-colors focus:outline-none"
              >
                <div className={`flex items-center justify-center w-7 h-7 rounded-md mr-3 transition-colors ${activeItem === item.id
                  ? 'bg-blue-500 text-white'
                  : 'text-gray-500 group-hover:text-gray-700'
                  }`}>
                  <item.icon className="text-base" />
                </div>

                <span className={`flex-1 text-left ${activeItem === item.id ? 'text-blue-900 font-semibold' : 'text-gray-700'
                  }`}>
                  {item.label}
                </span>

                {/* Expand Arrow */}
                {item.expandable && (
                  <div className={`transition-transform duration-200 ${showDriversSublist ? 'rotate-180' : ''}`}>
                    <MdExpandMore className={`${activeItem === item.id ? 'text-blue-600' : 'text-gray-400'}`} />
                  </div>
                )}
              </button>
            </div>

            {/* Submenu */}
            {item.expandable && showDriversSublist && (
              <div className="mt-1 ml-10 space-y-0.5">
                {item.subItems?.map((subItem) => (
                  <button
                    key={subItem.id}
                    onClick={() => setActiveItem(subItem.id)}
                    className={`w-full flex items-center px-3 py-2 rounded-md text-sm transition-all group ${activeItem === subItem.id
                      ? 'bg-blue-50 text-blue-900 font-medium'
                      : 'hover:bg-gray-50 text-gray-600'
                      }`}
                  >
                    <div className={`w-2 h-2 rounded-full mr-3 ${getStatusColor(subItem.status)}`} />
                    <span className="flex-1 text-left">{subItem.label}</span>
                  </button>
                ))}
              </div>
            )}
          </div>
        ))}
      </nav>
    </div>
  );
};

export default Sidebar;